import React, {Fragment} from "react"
import { Link } from "gatsby"
import { Row, Col, Container, Card } from "react-bootstrap"
import { imageFile } from '../../components/Utilities/Image-file'
import ModalEnquire from "../../components/Modal/ModalEnquire"
import FramerMotionAnimation from "../../components/Utilities/Animations/FramerMotion"


// PEOPLE TEASER component
//
// Expects:
// data, title

// data: nodes data object (title, drupal_internal__nid, path, created - per node) *
// title: list title for context

// EXAMPLE:
//
// <PeopleTeasers data={people_data} title="Authored by:" />


function filterPeople(data, title, colPattern, displayStyle) {
  // console.log(data)
  // console.log(title)

  // list output
  // -----------------------------------
  let list = []; // list layout container


  if(typeof data === 'object') {

    if(displayStyle === undefined) displayStyle = "large"


    let colIndex = 0
    let field_phone_number = ""
    // default column pattern
    if(colPattern === undefined) {
      colPattern = {
        xs:[12],
        md:[6],
        lg:[3]
      }
    }
    let colIndexTot = colPattern.xs.length
    let delayIndex = 0
    data.map(function(node, index) {
      if(!node){
        return false;
      }

      delayIndex += 1
      let timeDelay = delayIndex * 0.25

      let imageRelPath = ""
      if(node.relationships.field_image) {
        imageRelPath = imageFile(node.relationships.field_image, node.title)
      }

      // list layout format/markup
      // console.log(displayStyle)
      if(displayStyle === "large"){
        list.push (
          <Col key={index} xs={colPattern.xs[colIndex]} md={colPattern.md[colIndex]} lg={colPattern.lg[colIndex]} className="people">
            <FramerMotionAnimation delay={timeDelay} opacityStart={0} opacityEnd={1} transformXStart={0} transformXEnd={0} transformYStart={50} transformYEnd={0}>
            <Card>
              <Card.Body>
                <Link to={node.path.alias}>
                { imageRelPath }
                </Link>
                <Card.Title>
                  <Link to={node.path.alias}>
                    {node.title}
                  </Link>
                </Card.Title>
                <Card.Text>
                  <span>{node.field_job_title}</span>
                  <br/>
                  <ModalEnquire buttontext={node.field_email} emailto={node.field_email} emailtoname={node.title} modalcallnumber={field_phone_number} modalintro={"If you have any questions or would like to get in touch, submit a call back request and "+node.title+" will contact you as soon as possible."} classes={"text-link text-link--red text-left"} />
                </Card.Text>
                {/* <Link to={node.path.alias}>
                  <Button variant="primary">Full details</Button>
                </Link> */}
              </Card.Body>
            </Card>
            </FramerMotionAnimation>
          </Col>
        )
      }
      else if(displayStyle === "small-richtext") {
        list.push (
          <Fragment key="index">
            <Col xs={5} md={5} className="text-left people-teaser__image-wrapper">
              <Link to={node.path.alias} className="people-teaser__image-link">
              { imageRelPath }
              </Link>
            </Col>
            <Col xs={7} md={7} className="text-left">
              <Link to={node.path.alias} className="people-teaser__link">
                <span className="underline">{node.title}</span>
              </Link>
              <p className="people-teaser__job-title">{node.field_job_title}</p>
              {field_phone_number}
            </Col>
          </Fragment>
        )
      }
      else {
        list.push (
          <Fragment key="index">
            <Col xs={3} md={3} className="text-left people-teaser__image-wrapper">
              <Link to={node.path.alias} className="people-teaser__image-link">
              { imageRelPath }
              </Link>
            </Col>
            <Col xs={9} md={6} className="text-left">
              <Link to={node.path.alias} className="people-teaser__link">
                <span className="by">by&nbsp;</span><span className="underline">{node.title}</span>
              </Link>
              <p className="people-teaser__job-title">{node.field_job_title}</p>
              {field_phone_number}
            </Col>
          </Fragment>
        )
      }

      // loop through the column pattern
      colIndex += 1
      if(colIndex >= colIndexTot) colIndex = 0
      return true;

    })
  }

  if(list.length > 0){
    let returnTitle = ""
    if(title !== "") {
      returnTitle = (
        <Row>
          <Col>
            <h3>{title}</h3>
          </Col>
        </Row>
      )
    }
    const returnTeasers = (
      <Container fluid className="text-left">
        {returnTitle}
        <div className="people-teaser">
          <Row>
            {list}
          </Row>
        </div>
      </Container>
    )
    return (returnTeasers)
  }
  else {
    return (list)
  }

}



const PeopleTeasers = (props) => {

  return (
    <>
      {filterPeople(props.data, props.title, props.colPattern, props.displayStyle)}
    </>
  )
}


export default PeopleTeasers

